module.exports = __webpack_public_path__ + "1434fd3c.svg";